<template>
  <div class="body">
    <article class="newsDetail">
      <header class="hd">
        <p class="date" v-if="post.date">
          <em><strong>{{dateFormat(post.date, 'MM')}}</strong>/{{dateFormat(post.date, 'DD')}}</em>
          <span>{{dateFormat(post.date, 'YYYY')}}</span>
        </p>
        <h2>{{post.title.rendered}}</h2>
      </header>
      <section class="bd" v-html="post.content.rendered"></section>
    </article>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "NewsDetail",
  data() {
    return {
      post: {
        title: {},
        content: {},
      }
    };
  },
  mounted() {
    const { id } = this.$route.params;

    this.axios({
      url: `posts/${id}`
    }).then((data) => {
      this.post = data;
    });
  },
  methods: {
    dateFormat(dateString = '', format="YYYY-MM-DD") {
      if (!dateString) return '';

      return dayjs(dateString).format(format);
    },
  },
};
</script>

<style scoped lang="scss">
.body {
  padding: 120px 50px;
  background-color: #f8f8f8;
}
.newsDetail {
  margin: 0 auto;
  max-width: 960px;
  min-height: 300px;

  .hd {
    .date {
      margin-bottom: 45px;
      padding-left: 10px;
      font-size: 20px;
      line-height: 1;
      font-style: italic;
      font-weight: 300;
      border-left: 2px solid #e83e0b;

      em {
        display: block;
        font-size: 40px;
        font-style: italic;
        font-weight: 300;
      }
      span {
        display: block;
        padding: 4px 20px;
      }
    }

    h2 {
      font-size: 50px;
      line-height: 60px;
    }
  }

  .bd {
    padding: 36px 0;
    font-size: 19px;
    line-height: 1.52631;

    /deep/ p {
      margin: 1.5em 0;
      text-indent: 2em;
    }

    /deep/ img {
      display: block;
      margin: 1.5em 0;
      width: 100%;
      height: auto;
    }
  }
}


@media only screen and (max-width: 500px) {
  .body {
    padding: 50px 24px;
    background-color: #fff;
  }
  .newsDetail {
    .hd {
      .date {
        margin-bottom: 20px;
        padding-left: 8px;
        font-size: 12px;

        em {
          font-size: 24px;
        }
        span {
          padding: 2px 4px 0;
        }
      }

      h2 {
        font-size: 20px;
        line-height: 30px;
      }
    }

    .bd {
      padding: 8px 0;
      font-size: 12px;
    }
  }
}
</style>
